import { useQuery } from '@tanstack/react-query';

import { listContracts } from '../contracts/api';

/**
 * Points of sale where `customerId` holds an `ACTIVE` contract. More than one means
 * the API answers `OPERATING_UNIT_REQUIRED` unless the request names the point
 * (`design.md` T4), so the order and template forms ask for it up front.
 */
export function useCustomerUnitIds(customerId: string): string[] {
  const query = useQuery({
    queryKey: ['contracts-for-customer-units', customerId],
    queryFn: () => listContracts(customerId),
    enabled: customerId !== '',
  });

  return [
    ...new Set(
      (Array.isArray(query.data) ? query.data : [])
        .filter((contract) => contract.status === 'ACTIVE')
        .map((contract) => contract.operatingUnitId),
    ),
  ];
}
